module.exports = __webpack_public_path__ + "img/right-btn-arrow.bc10b0be.svg";